import { render } from "./WalletSelectModal.vue?vue&type=template&id=e3c5ee60&ts=true"
import script from "./WalletSelectModal.vue?vue&type=script&lang=ts"
export * from "./WalletSelectModal.vue?vue&type=script&lang=ts"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__